import React from "react";
import NewJobPostedCard from "./NewJobPostedCard";
import ReferralMilestoneCard from "./ReferralMilestoneCard";
import PlacementConfirmedCard from "./PlacementConfirmedCard";
import TierUpgradeCard from "./TierUpgradeCard";
import LeaderboardChampionCard from "./LeaderboardChampionCard";
import EditorialCard from "./EditorialCard";
import WeeklyStatsCard from "./WeeklyStatsCard";
import TrendingRoleCard from "./TrendingRoleCard";
import CandidateMatchAlertCard from "./CandidateMatchAlertCard";

/**
 * FeedCardDispatcher — reads card.type and renders the right component.
 *
 * Card types (PRD §5.1 + §5.2):
 *   new_job_posted       → NewJobPostedCard
 *   referral_milestone   → ReferralMilestoneCard
 *   placement_confirmed  → PlacementConfirmedCard
 *   tier_upgrade         → TierUpgradeCard
 *   leaderboard_champion → LeaderboardChampionCard
 *   weekly_stats         → WeeklyStatsCard
 *   trending_role        → TrendingRoleCard
 *   candidate_match      → CandidateMatchAlertCard
 *   editorial            → (Sprint 2 — to be implemented)
 *
 * Unknown card types render a generic fallback so the feed never breaks.
 */
const FeedCardDispatcher = ({ card }) => {
  // Sprint 3: wrap each card with an id for deep-link scrolling
  const wrapper = (children) => (
    <div id={`feed-card-${card.id}`} className="feed-card-wrapper">
      {children}
    </div>
  );

  switch (card.type) {
    case "new_job_posted":
      return wrapper(<NewJobPostedCard card={card} />);
    case "referral_milestone":
      return wrapper(<ReferralMilestoneCard card={card} />);
    case "placement_confirmed":
      return wrapper(<PlacementConfirmedCard card={card} />);
    case "tier_upgrade":
      return wrapper(<TierUpgradeCard card={card} />);
    case "leaderboard_champion":
      return wrapper(<LeaderboardChampionCard card={card} />);
    case "editorial":
      return wrapper(<EditorialCard card={card} />);
    case "weekly_stats":
      return wrapper(<WeeklyStatsCard card={card} />);
    case "trending_role":
      return wrapper(<TrendingRoleCard card={card} />);
    case "candidate_match":
      return wrapper(<CandidateMatchAlertCard card={card} />);
    default:
      // Generic fallback — never break the feed on an unknown card type
      return wrapper(
        <div style={styles.fallback}>
          <p style={styles.fallbackText}>{card.title || card.preview_text}</p>
        </div>
      );
  }
};

const styles = {
  fallback: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    marginBottom: "16px",
    padding: "20px",
  },
  fallbackText: {
    fontSize: "14px",
    color: "#64748b",
    margin: 0,
  },
};

export default FeedCardDispatcher;
